import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import AtpAvailableState from "@sonic/Store/Components/AvailableToPromise/AvailableToPromiseState";
import { customerActions } from "@sonic/Store/GemecoState";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<AtpAvailableState, DispatchProp<customerActions>>;

export const ToggleButton: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutReviewAndSubmit/ToggleAvailableToPromise",
        parameter: props.parameter,
    });
};

export const chain = [ToggleButton];

const toggleButton = createHandlerChainRunner(chain, "ToggleAvailableToPromise");
export default toggleButton;
